import React, { useState, useContext, useEffect } from "react";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfo,
  faLink,
  faDollarSign,
  faBolt,
  faLock
} from "@fortawesome/free-solid-svg-icons";

import { api_handler } from "../../services/api";

import { GlobalStateContext } from "../../state/GlobalContextProvider";

const InterfaceMenu = (props) => {
  const [interfaceName, setInterfaceName] = useState(null);
  const [interfaceDomain, setInterfaceDomain] = useState(null);

  

  useEffect(() => {

    const getInterface = async () => {
      var data = {
        interface_id: props.interface_id,
      };
      const api_rsp = await api_handler("int:view", data, "POST");
      setInterfaceName(api_rsp.data.name);
      setInterfaceDomain(api_rsp.data.portal_domain);
    };
    getInterface();
  }, [ props]);

  const themeState = useContext(GlobalStateContext);

  return (
    <div className="col-span-12 lg:col-span-4 xxl:col-span-3 flex lg:block flex-col-reverse">
      <div className="p-2 mb-3 ml-10 text-upper">
        <div className="interface_name">
          {" "}
          <p>Interface Name : {interfaceName}</p>{" "}
        </div>
        <div className="interface_portal">
          <p>
            Interface Domain :{" "}
            <a href={interfaceDomain} target="blank">
              {interfaceDomain}
            </a>
          </p>
        </div>
      </div>

      <div className={"section__menu " + themeState.theme}>
        <ul className="section_menu_ul">
          <li>
            <Link
              to={"/interfaces/" + props.interface_id + "/view/"}
              activeClassName="side-menu--active"
              className="side-menu"
            >
              <div className="side-menu__icon">
                <div className="dot">
                  <i>
                    <FontAwesomeIcon icon={faInfo} />
                  </i>
                </div>
              </div>
              <div className="side-menu__title">General Information</div>
            </Link>
          </li>

          <li>
            <Link
              to={"/interfaces/" + props.interface_id + "/account/"}
              activeClassName="side-menu--active"
              className="side-menu"
            >
              <div className="side-menu__icon">
                <div className="dot">
                  <i>
                    <FontAwesomeIcon icon={faLink} />
                  </i>
                </div>
              </div>
              <div className="side-menu__title">
                Account Information Access{" "}
              </div>
            </Link>
          </li>
          <li>
            <Link
              to={"/interfaces/" + props.interface_id + "/payment/"}
              activeClassName="side-menu--active"
              className="side-menu"
            >
              <div className="side-menu__icon">
                <div className="dot">
                  <i>
                    <FontAwesomeIcon icon={faDollarSign} />
                  </i>
                </div>
              </div>
              <div className="side-menu__title">Payment Initiation </div>
            </Link>
          </li>

          <li>
            <Link
              to={"/interfaces/" + props.interface_id + "/integrate/"}
              activeClassName="side-menu--active"
              className="side-menu"
            >
              <div className="side-menu__icon">
                <div className="dot">
                  <i>
                    <FontAwesomeIcon icon={faBolt} />
                  </i>
                </div>
              </div>
              <div className="side-menu__title">Integration </div>
            </Link>
          </li>
          <li>
            <Link
              to={"/interfaces/" + props.interface_id + "/security/"}
              activeClassName="side-menu--active"
              className="side-menu"
            >
              <div className="side-menu__icon">
                <div className="dot">
                  <i>
                    <FontAwesomeIcon icon={faLock} />
                  </i>
                </div>
              </div>
              <div className="side-menu__title">Security</div>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default InterfaceMenu;
